/// <amd-module name="Tfs/Platform/HeaderActions" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IHeaderActionData {
    /**
     * URL of the marketplace.
     */
    marketplaceUrl?: string;

    /**
     * URL of the default settings page.
     */
    settingsUrl?: string;

    /**
     * Determines whether project selector can be shown or not.
     */
    showProjectSelector?: boolean;

    /**
     * URL of sign-in page.
     */
    signInUrl?: string;

    /**
     * URL of the suite home page.
     */
    suiteHomeUrl?: string;
}

/**
 * Gets the action data regarding to the page header.
 *
 * @param pageContext The active page context.
 */
export function getHeaderActionData(pageContext: IVssPageContext): IHeaderActionData | undefined {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getData<IHeaderActionData>("ms.vss-tfs-web.header-action-data");
}
